import log from "loglevel";
import store from "../../app/stores/store";
import { CLSLogType } from "../../enums/log/clsLogType";
import { LogLevelType } from "../../enums/log/logLevelType";
import { ClsLog, ClsLogData } from "../../models/logging/clsLog";
import { Log } from "../../models/logging/log";
import { LogLevelRemote } from "../../models/logging/logLevelRemote";
import { getPayloadFromAccessToken } from "../auth/jwtTransform";
import envSettings from "../system/envSettings";
import { logLevelRemote } from "./logLevelRemoteUtil";

export const initLogger = () => {
  const customJSON = (log: LogLevelRemote, cls?: ClsLog, cprNumber?: string) => {
    const message = log.message;
    const level = log.level.label;

    let cprNumberForLogger = "";
    if (cprNumber) {
      cprNumberForLogger = cprNumber;
    } else {
      const accessToken = store.getState().authSlice.initializeToken?.access_token;
      if (accessToken) {
        const payload = getPayloadFromAccessToken(accessToken);
        if (payload?.eIdentifier) {
          cprNumberForLogger = payload?.eIdentifier;
        } else if (payload?.skatMedarbejderADNummer) {
          cprNumberForLogger = payload?.skatMedarbejderADNummer;
        }
      }
    }

    const isErrorLevel = level === LogLevelType[LogLevelType.error];
    const isWarningLevel = level === LogLevelType[LogLevelType.warn];

    const { logType, body, aftaleId, requestId, modulId, modulNavn } = (cls as ClsLog) || {};
    const storageStatus = logType === CLSLogType.AuditLog ? "audit" : "indsigt";

    const { errors, warnings, request, response } = (body as ClsLogData) || {};
    const clsLogBody = {
      cprNumber: cprNumberForLogger,
      errors: (errors ?? isErrorLevel) ? message : undefined,
      warnings: (warnings ?? isWarningLevel) ? message : undefined,
      request: request ?? undefined,
      response: response ?? undefined,
    } as ClsLogData;

    return {
      msg: message,
      level: level,
      stacktrace: log.stacktrace,
      cprNumber: cprNumberForLogger,
      clsRequest: {
        aftaleId: aftaleId ?? `${envSettings.AFTALEID_CLS_LOG}`,
        requestId: requestId ?? `${envSettings.REQUESTID_CLS_LOG}`,
        modulId: modulId ?? `${envSettings.MODULE_ID_CLS_LOG}`,
        modulNavn: modulNavn ?? `${envSettings.MODULE_NAME_CLS_LOG}`,
        logType: logType ?? CLSLogType.ApplikationsLog,
        dataSletSenest: storageStatus,
        body: JSON.stringify(clsLogBody) as string,
      },
    } as Log;
  };

  const isProductionMode = import.meta.env.PROD;
  if (isProductionMode) {
    log.setLevel(log.levels.INFO);
  } else {
    log.enableAll();
  }

  const isSendLogsEnabled = envSettings.SEND_LOGS === true;
  if (isSendLogsEnabled) {
    try {
      logLevelRemote.apply(log, {
        format: customJSON,
      });
    } catch (error) {
      console.trace("Cannot configure the logger correctly. Please, contract the administrator.", error);
    }
  }
};
